import React, { useCallback, useMemo } from 'react';

import { AdminRoleManagementFeaturesList } from 'common/enums/featuresList.enum';
import { FeatureActions } from 'common/models/roles-and-access/roleAccess.model';
import { useRolesAndAccess } from 'common/providers/AccessProvider';

function useAdminRoleManagementAccess() {
    const { featuresActions } = useRolesAndAccess();

    const adminRoleActionAccess = useMemo(
        () =>
            featuresActions.find(
                (ele: FeatureActions) =>
                    ele.featureKey === AdminRoleManagementFeaturesList.SET_UP_ROLES_FEATURES
            ),
        [featuresActions]
    );

    const getAdminRoleActionAccessDisabled = useCallback(
        (adminRoleActionAccess: FeatureActions) => {
            if (!adminRoleActionAccess.read && !adminRoleActionAccess.write) {
                return true;
            }
            return adminRoleActionAccess.read != adminRoleActionAccess.write;
        },
        []
    );

    const userPermissionActionAccess = useMemo(
        () =>
            featuresActions.find(
                (ele: FeatureActions) =>
                    ele.featureKey === AdminRoleManagementFeaturesList.SET_UP_USER_PERMISSION
            ),
        [featuresActions]
    );

    const getUserPermissionActionAccessDisabled = useCallback(
        (userPermissionActionAccess: FeatureActions) => {
            if (!userPermissionActionAccess.read && !userPermissionActionAccess.write) {
                return true;
            }
            return userPermissionActionAccess.read != userPermissionActionAccess.write;
        },
        []
    );

    return {
        isAdminRoleActionAccessDisabled:
            adminRoleActionAccess != undefined
                ? getAdminRoleActionAccessDisabled(adminRoleActionAccess)
                : true,
        isUserPermissionActionAccessDisabled:
            userPermissionActionAccess != undefined
                ? getUserPermissionActionAccessDisabled(userPermissionActionAccess)
                : true
    };
}

export default useAdminRoleManagementAccess;
